import { gql } from '@apollo/client';

// Query to get a single task
export const GET_TASK = gql`
  query GetTask($id: ID!) {
    getTask(id: $id) {
      id
      caseId
      clientId
      title
      description
      taskType
      priority
      status
      dueDate
      completedAt
      verifiedAt
      rejectedAt
      clientNotes
      staffNotes
      rejectionReason
      assignedBy
      assignedByName
      createdAt
      updatedAt
    }
  }
`;

// Query to list tasks by case
export const LIST_TASKS_BY_CASE = gql`
  query ListTasksByCase($caseId: ID!, $status: TaskStatus, $limit: Int, $nextToken: String) {
    listTasksByCase(caseId: $caseId, status: $status, limit: $limit, nextToken: $nextToken) {
      items {
        id
        caseId
        clientId
        title
        description
        taskType
        priority
        status
        dueDate
        completedAt
        verifiedAt
        rejectedAt
        clientNotes
        staffNotes
        rejectionReason
        assignedByName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Query to list tasks for current user
export const LIST_MY_TASKS = gql`
  query ListMyTasks($status: TaskStatus, $limit: Int, $nextToken: String) {
    listMyTasks(status: $status, limit: $limit, nextToken: $nextToken) {
      items {
        id
        caseId
        clientId
        title
        description
        taskType
        priority
        status
        dueDate
        completedAt
        verifiedAt
        rejectedAt
        clientNotes
        staffNotes
        rejectionReason
        assignedByName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Mutation to create a task (staff only)
export const CREATE_TASK = gql`
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      id
      caseId
      clientId
      title
      description
      taskType
      priority
      status
      dueDate
      assignedByName
      createdAt
      updatedAt
    }
  }
`;

// Mutation to update a task (staff only)
export const UPDATE_TASK = gql`
  mutation UpdateTask($id: ID!, $input: UpdateTaskInput!) {
    updateTask(id: $id, input: $input) {
      id
      title
      description
      taskType
      priority
      status
      dueDate
      staffNotes
      updatedAt
    }
  }
`;

// Mutation to complete a task (client)
export const COMPLETE_TASK = gql`
  mutation CompleteTask($id: ID!, $clientNotes: String) {
    completeTask(id: $id, clientNotes: $clientNotes) {
      id
      status
      completedAt
      clientNotes
      updatedAt
    }
  }
`;

// Mutation to verify a task (staff)
export const VERIFY_TASK = gql`
  mutation VerifyTask($id: ID!, $staffNotes: String) {
    verifyTask(id: $id, staffNotes: $staffNotes) {
      id
      status
      verifiedAt
      staffNotes
      updatedAt
    }
  }
`;

// Mutation to reject a task (staff)
export const REJECT_TASK = gql`
  mutation RejectTask($id: ID!, $rejectionReason: String!, $staffNotes: String) {
    rejectTask(id: $id, rejectionReason: $rejectionReason, staffNotes: $staffNotes) {
      id
      status
      rejectedAt
      rejectionReason
      staffNotes
      updatedAt
    }
  }
`;

// Mutation to delete a task (staff only)
export const DELETE_TASK = gql`
  mutation DeleteTask($id: ID!) {
    deleteTask(id: $id)
  }
`;

// Query to list task templates
export const LIST_TASK_TEMPLATES = gql`
  query ListTaskTemplates {
    listTaskTemplates {
      id
      name
      title
      description
      taskType
      priority
      defaultDueDays
      category
    }
  }
`;
